import {Component} from "react";

export default class extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const {
            // Global Props
            siteId,
            siteType,
            siteName,
            siteOwner,
            positionColumn,
            positionRow,
            lastUpdated,
            children,
            fullWidth

        } = this.props;


        let siteTypeName = "";
        switch (siteType) {
            case 1:
                siteTypeName = "Rainfall";
                break;
            case 2:
                siteTypeName = "Pipe Level";
                break;
            case 3:
                siteTypeName = "Overflow Site";
                break;
            case 4:
                siteTypeName = "Tidal Gauge";
                break;
            default:
                siteTypeName = "Rainfall;"
        }

        if( fullWidth ){
            return (
                <div className={"fullwidth-container site-column-" + positionColumn + " site-row-" + positionRow}>
                    { children }
                </div>
            )
        }

        return (
            <div id={"site-" + siteId}
                 className={"site-type-" + siteType + " site-container site-column-" + positionColumn + " site-row-" + positionRow}>

                <div className="site-left">
                    <h3 className="site-type">{siteTypeName}</h3>
                    { (siteName.length > 35)
                        ?
                        <h2 className="site-name" title={siteName}>
                            { siteName.substring(0,35) + String.fromCharCode(8230) }
                        </h2>
                        :
                        <h2 className="site-name">
                            { siteName }
                        </h2>
                    }

                    <p className="site-owner">{siteOwner}</p>
                    <div className="data-received">Data Received:<strong className="date">{lastUpdated}</strong></div>
                </div>
                <div className="site-right">
                    { children }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/site/site-component.js